import React from 'react';
import { Link } from 'react-router-dom';
import Brand from './Brand';

const PublicLayout = ({ children }) => {
    return (
        <div className="fs fs-auth">
            <header className="fs-auth-bar">
                <div className="wrap">
                    <Brand />
                    <div className="meta">
                        <a href="https://www.freightsource.co.uk/" target="_blank" rel="noreferrer">
                            freightsource.co.uk
                        </a>
                    </div>
                </div>
            </header>
            <main className="fs-auth-main">{children}</main>
        </div>
    );
};

export default PublicLayout;
